export { default } from './BasicMap';
